import { createContext, useContext, useState, useEffect } from 'react';

const ModoIdosoContext = createContext();

export function ModoIdosoProvider({ children }) {
    const [modoIdoso, setModoIdoso] = useState(() => {
        try {
            return localStorage.getItem('modoIdoso') === 'true';
        } catch {
            return false;
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('modoIdoso', modoIdoso ? 'true' : 'false');
        } catch {
            // silently ignore storage errors
        }
    }, [modoIdoso]);

    const toggleModoIdoso = () => setModoIdoso(prev => !prev);

    return (
        <ModoIdosoContext.Provider value={{ modoIdoso, toggleModoIdoso, setModoIdoso }}>
            {children}
        </ModoIdosoContext.Provider>
    );
}

export function useModoIdoso() {
    return useContext(ModoIdosoContext);
}
